export const API_LOADER_START = 'API_LOADER_START'
export const API_LOADER_STOP = 'API_LOADER_STOP'

export const API_DATA_STORE = 'API_DATA_STORE'
export const API_DATA_DESTROY = 'API_DATA_DESTROY'

export const REGISTER_API_CALL = 'REGISTER_API_CALL'
export const LOGIN_API_CALL = 'LOGIN_API_CALL'


export const PROFILE_UPDATE_API_CALL = 'PROFILE_UPDATE_API_CALL'


export const MYASSIGNMENT_GET_API_CALL = 'MYASSIGNMENT_GET_API_CALL'
export const MYASSIGNMENT_RECEIVE_DATA_API = 'MYASSIGNMENT_RECEIVE_DATA_API'



export const PATIENT_LIST_GET_API_CALL = 'PATIENT_LIST_GET_API_CALL'
export const PATIENT_LIST_RECEIVE_DATA_API = 'PATIENT_LIST_RECEIVE_DATA_API'

export const VIDEO_CALL_LIST_GET_API_CALL = 'VIDEO_CALL_LIST_GET_API_CALL'
export const VIDEO_CALL_LIST_RECEIVE_DATA = 'VIDEO_CALL_LIST_RECEIVE_DATA'
export const VIDEO_CALL_STORE_API_CALL = 'VIDEO_CALL_STORE_API_CALL'
export const VIDEO_CALL_DELETE_API_CALL = 'VIDEO_CALL_DELETE_API_CALL'

export const GET_ALL_MESSAGE_LIST = 'GET_ALL_MESSAGE_LIST'
export const GET_ALL_API_MESSAGE_RECEIVED = 'GET_ALL_API_MESSAGE_RECEIVED'

export const NOTES_STORE_API_CALL = 'NOTES_STORE_API_CALL'
